export default __webpack_public_path__ + "static/media/ready.9a263048.gif";